module.exports = __webpack_public_path__ + "img/Vector 37.5b3a9ccb.png";